import { PayloadAction, createSlice } from "@reduxjs/toolkit";

/** State of the current App */
export type AppState = {
  /**
   * Flag to hide certain functionalities that are not production ready in production environment.
   * This flag can be enabled by query param to test the functionalities in production environment.
   * i.e: enableBeta=true
   */
  isBetaTestingEnabled: boolean;

  /**
   * Flag to indicate if the app is running in development mode.
   * This adds ui elements that are not exposed to the customer.
   */
  isDevModeEnabled: boolean;
};

const initialAppState: AppState = {
  /** Beta testing is enabled in non-production environments or if the user has enabled with queryParam. */
  isBetaTestingEnabled: false,

  /** Dev mode is enabled if the user has enabled it with queryParam. */
  isDevModeEnabled: false,
};

/**
 * Slice to access state of general app meta data
 */
const appSlice = createSlice({
  name: "app",
  initialState: initialAppState,
  reducers: {
    setIsBetaTestingEnabled(state, action: PayloadAction<boolean>) {
      state.isBetaTestingEnabled = action.payload;
    },

    setIsDevModeEnabled(state, action: PayloadAction<boolean>) {
      state.isDevModeEnabled = action.payload;
    },

    resetAppState: () => initialAppState,
  },

  selectors: {
    /** Selector to get the entire app state */
    appStateSelector: (state) => state,
  },
});

export const { setIsBetaTestingEnabled, setIsDevModeEnabled, resetAppState } =
  appSlice.actions;

export const { appStateSelector } = appSlice.selectors;

export const appReducer = appSlice.reducer;
